import React from 'react';
import { withStyles, Grid } from '@material-ui/core';

class MDivider extends React.Component {
    render() {
        const { width, height, backgroundColor, borderRadius, marginH } = this.props
        return (
            <Grid style={{
                width: width,
                height: height,
                backgroundColor: backgroundColor,
                borderRadius: borderRadius,
                marginLeft: marginH,
                marginRight: marginH
            }} />
        );
    }
}

export default withStyles((theme) => ({

}))(MDivider);